<template>
  <div class="col-12 mt-2">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
      <symbol
        id="exclamation-triangle-fill"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path
          d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
        />
      </symbol>

      <symbol id="question-circle" fill="currentColor" viewBox="0 0 16 16">
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
        />
        <path
          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
        />
      </symbol>
    </svg>

    <div
      v-if="isCurrentPageHasAlerts"
      class="alert alert-warning"
      role="alert"
    >
      <div
        v-for="error in getCurrentPageAlerts"
        :key="error.Key"
        :value="error.Value"
      >
        <div
          class="d-flex align-items-center p-1"
        >
          <svg
            class="bi flex-shrink-0 mr-2"
            width="24"
            height="24"
            role="img"
            aria-label="Warning:"
          >
            <use xlink:href="#exclamation-triangle-fill" />
          </svg>
          <div class="mr-2">
            {{ error.ModelError[0].ErrorMessage }}
            <!-- <a
              v-if="isSummaryPage"
              href="#void"
              @click="goTabAndFocus(error.Key)"
              class="alert-link"
              >Düzenle</a
            > -->
          </div>
          <abbr :title="translate('errors.thisFieldIsRequired')" class="initialism question-mark">
            <svg
              class="bi flex-shrink-0"
              width="24"
              height="24"
              role="img"
              aria-label="Warning:"
            >
              <use xlink:href="#question-circle" />
            </svg>
          </abbr>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    validationData: {
      type: Array,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    refs: {
      type: Object,
    },
  },
  computed: {
    isSummaryPage() {
      return this.value == "arsivler";
    },
    isCurrentPageHasAlerts(){
      return this.getCurrentPageAlerts.length > 0;
    },
    getCurrentPageAlerts(){
      if(this.validationData && this.validationData.length > 0)
        return this.validationData.filter(x => this.ifCurrentPageIs(this.getItemTabNameFromRefName(x.Key)));
      else
        return [];
    }
  },
  methods: {
    ifCurrentPageIs(key) {
      //return this.value == "arsivler" ? true : this.value == key;
      return  this.value == key;
    },

    getVueFromElement(el) {
      while (el) {
        if (el.__vue__) {
          return el.__vue__;
        } else {
          el = el.parentNode;
        }
      }
    },
    getItemTab(item) {
      if (item == null) return null;

      let parent = item.$parent;

      if (!parent) parent = this.getVueFromElement(item);

      while (parent && parent.$options._componentTag !== "incoming-tab-content") {
        parent = parent.$parent;
      }
      // console.log("getItemTab",parent);
      return parent;
    },
    getItemTabNameFromRefItem(refItem) {
      var tabComponent = this.getItemTab(refItem);
      if (tabComponent) return tabComponent.tabName;
      else return null;
    },
    getItemTabNameFromRefName(refName) {
      var refItem = this.getRefItem(refName);
      var tabComponent = this.getItemTab(refItem);
      if (tabComponent) return tabComponent.tabName;
      else return null;
    },
    getRefItem(ref) {
      var refName = ref.split(".").slice(-1)[0];
      var refItem = this.refs[refName];

      if (!refItem) refItem = document.getElementsByName(refName)[0];
      // console.log("refItem",refItem);
      // console.log("refName",refName);
      return refItem;
    },
    goTab(key) {
      var tab = this.tabs.filter((x) => x.key == key)[0];

      this.$emit("input", key);
      this.$emit("change", tab);
    },
    goTabAndFocus(refName) {
      var refItem = this.getRefItem(refName);

      if (refItem) {
        this.goTab(this.getItemTabNameFromRefItem(refItem));

        setTimeout(() => {
          if (refItem.$el) refItem.$el.focus();
          else refItem.focus();
        }, 50);
      }
    },
  },
};
</script>
<style scoped>
.alert .question-mark {
  position: absolute;
  right: 0.5rem;
  top: auto;
  z-index: 2;
}
</style>